import React from 'react'
import navHeader from './navbar.module.css'

const Navbar = () => {
  const container = {
    display: 'flex',
  }
  const TopLevelMenu = {
    paddingLeft: '5px',
    color: '#d22528',
  }
  const TopLevelMenuLH = {
    paddingLeft: '5px',
    color: '#d22528',
    lineHeight: '1.5',
  }
  const SubMenuIndent = {
    paddingLeft: '20px',
    fontSize: '16px',
  }

  const SubMenuIndentLH = {
    paddingLeft: '20px',
    fontSize: '16px',
    lineHeight: '1.5',
  }

  return (
    <div style={container}>
      <div className={navHeader.MenuContainer}>
        <div>
          <div style={{ zIndex: '0' }}>
            <a href="/en-CA" title="CREA Logo" alt="CREA Logo">
              <div className="CREA_Dark_Logo" />
              <div className="CREA_Light_Logo" />
            </a>
          </div>
        </div>
        <div className={navHeader.Menu}>
          <ul id="Dark_Header_style">
            <li>
              <a href="#">
                <span>Who We Are</span>
              </a>
              <ul className={navHeader.subMenu}>
                <li>
                  <a
                    href="https://www.crea.ca/who-we-are/mission/"
                    style={TopLevelMenu}
                  >
                    Our Mission
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/who-we-are/mission/values-strategic-overview/"
                    style={SubMenuIndent}
                  >
                    Our Values & Strategic Overview
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/who-we-are/mission/deia-commitments/"
                    style={SubMenuIndent}
                  >
                    Our DEIA Commitments
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/who-we-are/realtor-association-community/"
                    style={TopLevelMenu}
                  >
                    REALTOR® Association Community
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/who-we-are/leadership/"
                    style={TopLevelMenu}
                  >
                    Our Leadership
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/who-we-are/leadership/volunteer-committees/"
                    style={SubMenuIndent}
                  >
                    Our Volunteer Committees
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/who-we-are/the-realtor-difference/"
                    style={TopLevelMenu}
                  >
                    The REALTOR® Difference
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/who-we-are/the-realtor-difference/become-a-realtor/"
                    style={SubMenuIndent}
                  >
                    Become a REALTOR®
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/who-we-are/the-realtor-difference/new-realtors/"
                    style={SubMenuIndent}
                  >
                    New REALTORS®
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/who-we-are/the-realtor-difference/brokers/"
                    style={SubMenuIndent}
                  >
                    Brokers
                  </a>
                </li>
              </ul>
            </li>{' '}
            <li>
              <a href="#">
                <span>Advocacy</span>
              </a>
              <ul className={navHeader.subMenu}>
                <li>
                  <a
                    href="https://www.crea.ca/advocacy/political-advocacy/"
                    style={TopLevelMenu}
                  >
                    Political Advocacy
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/advocacy/political-advocacy/pac-days/"
                    style={SubMenuIndent}
                  >
                    PAC Days
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/advocacy/political-advocacy/past-successes/"
                    style={SubMenuIndent}
                  >
                    Past Successes
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/advocacy/realtor-recommendations/"
                    style={TopLevelMenu}
                  >
                    REALTOR® Reccomendations
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/advocacy/realtor-recommendations/protecting-homeownership/"
                    style={SubMenuIndent}
                  >
                    Protecting Homeownership
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/advocacy/realtor-recommendations/protecting-homeownership/homeownership-dividend-for-canadians/"
                    style={SubMenuIndent}
                  >
                    The Homeownership Dividend for Canadians
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#">
                <span>REALTOR® & Consumer Tech</span>
              </a>
              <ul className={navHeader.subMenu}>
                <li>
                  <a
                    href="https://www.crea.ca/technology/realtor-ca-for-canadians/"
                    style={TopLevelMenu}
                  >
                    REALTOR.ca for Canadians
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/technology/realtor-ca-for-canadians/"
                    style={TopLevelMenu}
                  >
                    REALTOR.ca for REALTORS®
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/technology/realtor-ca-for-realtors/realtor-ca-tools/"
                    style={SubMenuIndent}
                  >
                    REALTOR.ca Tools
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/technology/realtor-ca-for-realtors/realtor-ca-tools/realtor-ca-ddf/"
                    style={SubMenuIndent}
                  >
                    REALTOR.ca DDF®
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/technology/realtor-ca-for-realtors/realtor-ca-tools/listing-stats-app/"
                    style={SubMenuIndent}
                  >
                    Listing Stats App
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/technology/crea-webforms/"
                    style={TopLevelMenu}
                  >
                    CREA WEBForms®
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#">
                <span>Standards & Programs</span>
              </a>
              <ul className={navHeader.subMenu}>
                <li>
                  <a
                    href="https://www.crea.ca/standards-programs/reputation/"
                    style={TopLevelMenu}
                  >
                    Reputation
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/standards-programs/reputation/national-ad-campaign/"
                    style={SubMenuIndent}
                  >
                    National Ad Campaign
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/standards-programs/reputation/learning-development/"
                    style={SubMenuIndent}
                  >
                    Learning & Development
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/standards-programs/realtor-code/"
                    style={TopLevelMenu}
                  >
                    REALTOR® Code
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/standards-programs/reputation/learning-development/"
                    style={TopLevelMenu}
                  >
                    Trademark Protection & Competition
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/standards-programs/trademark-protection-competition/pledge-of-competition/"
                    style={SubMenuIndent}
                  >
                    Pledge of Completion
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/standards-programs/programs/"
                    style={TopLevelMenu}
                  >
                    Our Programs
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/standards-programs/programs/realtors-care/"
                    style={SubMenuIndent}
                  >
                    REALTORS Care®
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/standards-programs/programs/crea-global/"
                    style={SubMenuIndent}
                  >
                    CREA Global
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/standards-programs/programs/young-professionals-network/"
                    style={SubMenuIndent}
                  >
                    YPN Connection
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#">
                <span>Housing Market Analysis</span>
              </a>
              <ul className={navHeader.subMenu}>
                <li>
                  <a
                    href="https://www.crea.ca/housing-market-stats/canadian-housing-market-stats/"
                    style={TopLevelMenu}
                  >
                    Canadian Housing Market Stats
                  </a>
                </li>
                <li>
                  <a href="/" style={SubMenuIndent}>
                    Monthly Stats Report
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/housing-market-stats/canadian-housing-market-stats/monthly-housing-stats-highlights/"
                    style={SubMenuIndent}
                  >
                    Monthly Housing Stats highlights
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/housing-market-stats/canadian-housing-market-stats/quarterly-forecasts/"
                    style={SubMenuIndent}
                  >
                    Quarterly Forecasts
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/housing-market-stats/canadian-housing-market-stats/national-price-map/"
                    style={SubMenuIndent}
                  >
                    National Price Map
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/housing-market-stats/mls-home-price-index/"
                    style={TopLevelMenu}
                  >
                    MLS® Home Price Index (HPI)
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/housing-market-stats/mls-home-price-index/about-hpi/"
                    style={SubMenuIndent}
                  >
                    About MLS® HPI
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/housing-market-stats/mls-home-price-index/getting-started/"
                    style={SubMenuIndent}
                  >
                    How Does the MLS® HPI Help Me?
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/housing-market-stats/mls-home-price-index/hpi-tool/"
                    style={SubMenuIndent}
                  >
                    Try the MLS® HPI Tool
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/housing-market-stats/mls-home-price-index/resources/"
                    style={SubMenuIndent}
                  >
                    Reference Materials
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#">
                <span>Media Hub</span>
              </a>
              <ul className={navHeader.subMenu}>
                <li>
                  <a
                    href="https://www.crea.ca/media-hub/news/"
                    style={TopLevelMenu}
                  >
                    News Releases & Statements
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/media-hub/events-sponsorships/"
                    style={TopLevelMenu}
                  >
                    Events & Sponsorships
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/media-hub/annual-reports/"
                    style={TopLevelMenu}
                  >
                    Annual Reports
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/media-hub/newsletters/"
                    style={TopLevelMenu}
                  >
                    Newsletters
                  </a>
                </li>
                <li>
                  <a href="http://news2me.crea.ca/" style={SubMenuIndent}>
                    News2Me For REALTORS®
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.realtor.ca/my-account#section=Communications"
                    style={SubMenuIndent}
                  >
                    REALTOR.ca Newsletters For Canadians
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/media-hub/blogs/"
                    style={TopLevelMenu}
                  >
                    Blogs
                  </a>
                </li>
                <li>
                  <a href="https://www.creacafe.ca/" style={SubMenuIndent}>
                    CREA Café Blog for REALTORS®
                  </a>
                </li>
                <li>
                  <a href="https://www.realtorscare.ca/" style={SubMenuIndent}>
                    REALTORS Care® Stories
                  </a>
                </li>
                <li>
                  <a href="https://www.realtor.ca/blog" style={SubMenuIndent}>
                    REALTOR.ca Living Blog for Canadians
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/media-hub/real-time-podcast/"
                    style={TopLevelMenu}
                  >
                    REAL TIME Podcast
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/media-hub/publications/"
                    style={TopLevelMenu}
                  >
                    CREA Publications
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.crea.ca/media-hub/covid-19/"
                    style={TopLevelMenu}
                  >
                    COVID-19 Ressources
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Navbar
